/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  Divider,
  TablePagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Link,
  Avatar,
  CircularProgress,
  Grid,
  Button,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Dialog,
  IconButton,
  Collapse,
  TextField,
  MenuItem,
  useTheme,
} from "@mui/material";
// import useAuth from '../../hooks/useAuth';
import { useCallback, useState, useEffect } from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import useMounted from "../../../hooks/useMounted";
import * as moment from "moment";
import { relaunchApi } from "../../../api/relaunchApi";
import { ProgressBar } from "../session";
import ErrorIcon from "@mui/icons-material/Error";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import WarningIcon from "@mui/icons-material/Warning";
import { alpha } from "@mui/material/styles";
import numeral from "numeral";
import Label from "../../Label";
import { styled } from "@mui/styles";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  frFR,
} from "@mui/x-data-grid";
import CustomersFollowUpFullScreenTable from "./CustomersFollowUpFullScreenTable";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FilterListIcon from "@mui/icons-material/FilterList";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useAuth from "../../../hooks/useAuth";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Pill } from "../../ui-kit";
import { getProfessionTone, getTone, toneAlpha, lightVeil, darkVeil, greyAlpha, grey } from "../../../theme/tones";
import usePermissions from '../../../hooks/usePermissions';

function renderProgress(params) {
  return <ProgressBar value={Number(params.value)} />;
}

const CustomersFollowUpTable = () => {
  const theme = useTheme();
  const detailStyles = {
    borderLeft: "4px solid",
    borderLeftColor: "success.main",
    backgroundColor: alpha(theme.palette.text.disabled, 0.08),
    borderRadius: "16px",
    p: 3,
    my: 2,
    border: "1px solid",
    borderColor: "divider",
    whiteSpace: "pre-line",
  };
  const mounted = useMounted();
  const [page, setPage] = useState(0);
  const { user } = useAuth();
  const { can } = usePermissions();
  const [limit, setLimit] = useState(5);
  const [customers, setCustomers] = useState([]);
  const [numberCustomers, setNumberCustomers] = useState(0);
  const [amounts, setAmounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [openFullScreen, setOpenFullScreen] = useState(false);
  // const classes = useStyles();
  const [clickedId, setClickedId] = useState(-1);

  const [filterFormation, setFilterFormation] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterProgression, setFilterProgression] = useState("");
  const [filterLearner, setFilterLearner] = useState("");
  const [filterFormat, setFilterFormat] = useState("");
  const [filterFinanceur, setFilterFinanceur] = useState("");
  const [allFinanciers, setAllFinanciers] = useState([]);

  const CustomToolbar = () => {
    return can('shift.export', user.id_service === 0) ? (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarExport />
      </GridToolbarContainer>
    ) : (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
      </GridToolbarContainer>
    );
  };

  const getCustomersForFollowUp = useCallback(async () => {
    try {
      const data = await relaunchApi.getCustomersForFollowUp(
        localStorage.getItem("accessToken")
      );
      if (data.length === 0) {
        throw new Error("Aucun apprenant dans le suivi");
      }
      if (mounted.current) {
        setCustomers(data.customers);
        setNumberCustomers(data.numberCustomers.number);
        setAmounts(data.amounts);
        setAllFinanciers(data.allFinanciers || []);
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted]);

  useEffect(() => {
    getCustomersForFollowUp();
  }, [getCustomersForFollowUp]);

  useEffect(() => {
    setRows(
      customers.map((item, index) => ({
        id: `${item.email}_${item.name}_${index}`,
        customerId: item.id,
        formationId: item.formation_id,
        email: item.email,
        phone: item.phone,
        profession: item.profession,
        firstname: item.firstname,
        lastname: item.lastname,
        source: item.source,
        status: item.status,
        last_connection:
          item.last_connection !== null
            ? moment(item.last_connection).format("DD/MM/YYYY HH:mm")
            : "",
        start_date:
          item.start_date !== null
            ? moment(item.start_date).format("DD/MM/YYYY")
            : "",
        end_date:
          item.end_date !== null
            ? moment(item.end_date).format("DD/MM/YYYY")
            : "",
        start_relaunch_date:
          item.start_relaunch_date !== null
            ? moment(item.start_relaunch_date).format("DD/MM/YYYY")
            : "",
        first_turn_end_date:
          item.first_turn_end_date !== null
            ? moment(item.first_turn_end_date).format("DD/MM/YYYY")
            : "",
        progression: Math.round(item.progression),
        subscribed_at:
          item.subscribed_at !== null
            ? moment(item.subscribed_at).format("DD/MM/YYYY HH:mm")
            : "",
        formation_name: item.name,
        real_price: item.real_price,
        civility: item.civility,
        action: item.action,
        step: item.step,
        duration: item.duration,
        sessionId: item.session_id,
        numberSession: item.number_session,
        programNumber: item.program_number,
        agreementSent: item.agreement_sent,
        agreementCompleted: item.agreement_completed,
        honorSent: item.honor_sent,
        honorCompleted: item.honor_completed,
        notCall: item.not_call,
        format: item.format,
        financeur: item.financeur,
      }))
    );
  }, [customers]);

  const filteredRows = rows.filter((row) => {
    const formationMatch =
      filterFormation === "" ||
      (row.formation_name &&
        row.formation_name
          .toLowerCase()
          .includes(filterFormation.toLowerCase()));
    const statusMatch =
      filterStatus === "" ||
      (row.status &&
        row.status.toLowerCase().includes(filterStatus.toLowerCase()));
    const progressionMatch =
      filterProgression === "" ||
      (row.progression &&
        row.progression.toString().includes(filterProgression));
    const learnerMatch =
      filterLearner === "" ||
      (row.firstname &&
        row.firstname.toLowerCase().includes(filterLearner.toLowerCase())) ||
      (row.lastname &&
        row.lastname.toLowerCase().includes(filterLearner.toLowerCase()));
    const formatMatch =
      filterFormat === "" ||
      (row.format &&
        row.format.toLowerCase().includes(filterFormat.toLowerCase()));

    const financeurMatch = 
      filterFinanceur === "" ||
      (row.financeur &&
        row.financeur.toLowerCase().includes(filterFinanceur.toLowerCase()));
        
    return (
      formationMatch &&
      statusMatch &&
      progressionMatch &&
      learnerMatch &&
      formatMatch &&
      financeurMatch
    );
  });

  // Couleur de profession : table commune à toutes les listes
  // (src/theme/tones.js), pour qu'« Infirmier » ait la même teinte partout.
  const getProfessionBadge = (profession) => (
    <Pill
      tone={getProfessionTone(profession)}
      label={profession}
      size="small"
      sx={{ mt: 0.5 }}
    />
  );

  const dateSortComparator = (v1, v2) => {
    const d1 = v1 && v1 !== '-' ? moment(v1, 'DD/MM/YYYY') : null;
    const d2 = v2 && v2 !== '-' ? moment(v2, 'DD/MM/YYYY') : null;
    if (!d1 && !d2) return 0;
    if (!d1) return -1;
    if (!d2) return 1;
    return d1.valueOf() - d2.valueOf();
  };

  const columns = [
    {
      field: "+",
      renderCell: (cellValues) => (
        <IconButton
          onClick={() => {
            clickedId === cellValues.row.id
              ? setClickedId(-1)
              : setClickedId(cellValues.row.id);
          }}
          sx={{ color: "text.secondary" }}
        >
          {cellValues.row.id === clickedId ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )}
        </IconButton>
      ),
      width: 60,
    },
    {
      field: "lastname",
      headerName: "Apprenant",
      renderCell: (cellValues) => (
        <Box sx={{ py: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.2 }}>
            <Link
              component={RouterLink}
              to={`/dashboard/customers/${cellValues.row.customerId}`}
              sx={{
                textDecoration: "none",
                fontWeight: 800,
                fontSize: "0.85rem",
                color: "primary.main",
                "&:hover": { color: "primary.dark" }
              }}
            >
              {`${cellValues.row.firstname} ${cellValues.row.lastname}`}
            </Link>
            {cellValues.row.profession && getProfessionBadge(cellValues.row.profession)}
          </Box>
          <Collapse in={cellValues.id === clickedId}>
            <Box sx={detailStyles}>
              <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.7, color: "text.primary" }}>
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Civilité : </span> {cellValues.row.civility}
                <br />
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Téléphone : </span> {cellValues.row.phone}
                <br />
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Email : </span> {cellValues.row.email}
                <br />
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Dernière connexion : </span> {cellValues.row.last_connection}
              </Typography>
            </Box>
          </Collapse>
        </Box>
      ),
      width: 400,
    },
    {
      field: "formation_name",
      headerName: "Nom de la formation",
      renderCell: (cellValues) => (
        <Box sx={{ py: 1, width: '100%', whiteSpace: 'normal' }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.2, width: '100%' }}>
            <Link
              component={RouterLink}
              to={`/dashboard/formations/${cellValues.row.formationId}`}
              sx={{
                textDecoration: "none",
                fontWeight: 800,
                fontSize: "0.85rem",
                color: "text.primary",
                "&:hover": { color: "primary.main" },
                whiteSpace: "normal",
                display: "inline-block",
                lineHeight: 1.3
              }}
            >
              {cellValues.row.formation_name}
            </Link>
            <Link
              component={RouterLink}
              to={`/dashboard/session/${cellValues.row.sessionId}`}
              sx={{
                textDecoration: "none",
                fontWeight: 700,
                fontSize: "0.78rem",
                color: "text.secondary",
                "&:hover": { color: "primary.main" }
              }}
            >
              Session n° : {cellValues.row.numberSession}
            </Link>
          </Box>
          <Collapse in={cellValues.id === clickedId}>
            <Box sx={detailStyles}>
              <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.7, color: "text.primary" }}>
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Source : </span> {cellValues.row.source}
                <br />
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Prix : </span> {cellValues.row.real_price} €
                <br />
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Étape : </span> {cellValues.row.step}
                <br />
                <span style={{ fontWeight: 700, color: getTone('emerald').base }}>Durée : </span> {cellValues.row.duration}
              </Typography>
            </Box>
          </Collapse>
        </Box>
      ),
      width: 350,
    },
    {
      field: "format",
      headerName: "Format",
      width: 150,
    },
    {
      field: "start_date",
      headerName: "Dates de session",
      renderCell: (cellValues) => (
        <Box sx={{ fontSize: "0.8rem", lineHeight: 1.4, color: "text.primary" }}>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Début : </span>
            {cellValues.row.start_date}
          </div>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Fin : </span>
            {cellValues.row.end_date}
          </div>
        </Box>
      ),
      sortComparator: dateSortComparator,
      width: 150,
    },
    {
      field: "start_relaunch_date",
      headerName: "Dates importantes",
      width: 160,
      renderCell: (cellValues) => (
        <Box sx={{ fontSize: "0.8rem", lineHeight: 1.4, color: "text.primary" }}>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Relance : </span>
            {!cellValues.row.start_relaunch_date ? "-" : cellValues.row.start_relaunch_date}
          </div>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Fin U.Clé : </span>
            {!cellValues.row.first_turn_end_date ? "-" : cellValues.row.first_turn_end_date}
          </div>
        </Box>
      ),
      sortComparator: dateSortComparator,
    },
    {
      field: "status",
      headerName: "Statut",
      renderCell: (cellValues) => {
        let bg = toneAlpha('neutral', 0.08);
        let color = getTone('neutral').base;
        let border = toneAlpha('neutral', 0.2);

        if (cellValues.row.status === "Inscrit") {
          bg = toneAlpha('emerald', 0.06);
          color = getTone('emerald').base;
          border = toneAlpha('emerald', 0.2);
        } else if (cellValues.row.status === "InscritD") {
          bg = toneAlpha('indigo', 0.06);
          color = getTone('indigo').base;
          border = toneAlpha('indigo', 0.2);
        } else if (cellValues.row.status === "Décalé") {
          bg = toneAlpha('amber', 0.06);
          color = getTone('amber').base;
          border = toneAlpha('amber', 0.2);
        } else if (cellValues.row.status === "Annulation" || cellValues.row.status === "À décaler") {
          bg = toneAlpha('rose', 0.06);
          color = getTone('rose').base;
          border = toneAlpha('rose', 0.2);
        }

        return (
          <Box sx={{
            px: 1.5,
            py: 0.5,
            borderRadius: "12px",
            fontSize: "0.75rem",
            fontWeight: 700,
            backgroundColor: bg,
            color,
            border: "1px solid",
            borderColor: border,
            display: "inline-flex",
            alignItems: "center"
          }}>
            {cellValues.row.status}
          </Box>
        );
      },
      editable: false,
      width: 120,
    },
    {
      field: "progression",
      headerName: "Progression",
      renderCell: renderProgress,
      editable: false,
      width: 120,
    },
    {
      field: "action",
      headerName: "Action",
      renderCell: (cellValues) => {
        let bg = toneAlpha('neutral', 0.08);
        let color = getTone('neutral').base;
        let border = toneAlpha('neutral', 0.2);

        if (cellValues.row.action === "Relance Tour 1") {
          bg = toneAlpha('emerald', 0.06);
          color = getTone('emerald').base;
          border = toneAlpha('emerald', 0.2);
        } else if (cellValues.row.action === "Relance Tour 2") {
          bg = toneAlpha('amber', 0.06);
          color = getTone('amber').base;
          border = toneAlpha('amber', 0.2);
        } else if (cellValues.row.action === "Décalé") {
          bg = toneAlpha('indigo', 0.06);
          color = getTone('indigo').base;
          border = toneAlpha('indigo', 0.2);
        }

        return (
          <Box sx={{
            px: 1.5,
            py: 0.5,
            borderRadius: "12px",
            fontSize: "0.75rem",
            fontWeight: 700,
            backgroundColor: bg,
            color,
            border: "1px solid",
            borderColor: border,
            display: "inline-flex",
            alignItems: "center"
          }}>
            {cellValues.row.action}
          </Box>
        );
      },
      editable: false,
      width: 130,
    },
    {
      field: "financeur",
      headerName: "Financeur",
      width: 200,
    },
  ];

  const handleCustomers = async (pageChoice, limitChoice) => {
    try {
      setIsLoading(true);
      const data = await relaunchApi.getCustomersForFollowUp(
        localStorage.getItem("accessToken"),
        pageChoice,
        limitChoice
      );
      setCustomers(data.customers);
      setNumberCustomers(data.numberCustomers.number);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    handleCustomers(newPage, limit);
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
    handleCustomers(page, parseInt(event.target.value, 10));
  };

  const handleCloseFullScreen = () => {
    setOpenFullScreen(false);
  };

  // const classesDivider = useStylesDivider();

  return (
    <>
      {amounts !== null && (
        <Grid
          container
          spacing={3.5}
          sx={{ mb: 5 }}
        >
          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: `1px solid ${toneAlpha('emerald', 0.15)}`,
                backgroundColor: 'background.paper',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? `0 20px 40px ${toneAlpha('emerald', 0.04)}` 
                  : `0 20px 40px ${toneAlpha('emerald', 0.1)}`,
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: `0 25px 50px ${toneAlpha('emerald', 0.15)}`,
                  borderColor: 'success.main'
                }
              }}
            >
              <Avatar
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? toneAlpha('emerald', 0.08) : toneAlpha('emerald', 0.15),
                  color: 'success.main',
                  width: 52,
                  height: 52,
                  boxShadow: `0 4px 12px ${toneAlpha('emerald', 0.05)}`
                }}
                variant="rounded"
              >
                <Box
                  sx={{
                    animation: 'pulse ease 1.5s infinite',
                    borderRadius: '50%',
                    p: 0.5,
                    '@keyframes pulse': {
                      '0%': { boxShadow: 'none' },
                      '100%': { boxShadow: `0px 0px 0px 8px ${alpha(getTone('emerald').base, 0.15)}` }
                    }
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: 'success.main',
                      borderRadius: '50%',
                      height: 12,
                      width: 12
                    }}
                  />
                </Box>
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  Inscrits
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts.Inscrit).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>
          
          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: `1px solid ${toneAlpha('blue', 0.15)}`,
                backgroundColor: 'background.paper',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? `0 20px 40px ${toneAlpha('blue', 0.04)}` 
                  : `0 20px 40px ${toneAlpha('blue', 0.1)}`,
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: `0 25px 50px ${toneAlpha('blue', 0.15)}`,
                  borderColor: 'primary.main'
                }
              }}
            >
              <Avatar
                variant="rounded"
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.08) : toneAlpha('blue', 0.15),
                  color: 'primary.main',
                  width: 52,
                  height: 52,
                  boxShadow: `0 4px 12px ${toneAlpha('blue', 0.05)}`
                }}
              >
                <TimelapseIcon fontSize="medium" />
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  InscritD
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts.InscritD).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>

          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: `1px solid ${toneAlpha('amber', 0.15)}`,
                backgroundColor: 'background.paper',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? `0 20px 40px ${toneAlpha('amber', 0.04)}` 
                  : `0 20px 40px ${toneAlpha('amber', 0.1)}`,
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: `0 25px 50px ${toneAlpha('amber', 0.15)}`,
                  borderColor: 'warning.main'
                }
              }}
            >
              <Avatar
                variant="rounded"
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? toneAlpha('amber', 0.08) : toneAlpha('amber', 0.15),
                  color: 'warning.main',
                  width: 52,
                  height: 52,
                  boxShadow: `0 4px 12px ${toneAlpha('amber', 0.05)}`
                }}
              >
                <ErrorIcon fontSize="medium" />
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  À décaler
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts['À décaler']).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>

          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: `1px solid ${toneAlpha('rose', 0.15)}`,
                backgroundColor: 'background.paper',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? `0 20px 40px ${toneAlpha('rose', 0.04)}` 
                  : `0 20px 40px ${toneAlpha('rose', 0.1)}`,
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: `0 25px 50px ${toneAlpha('rose', 0.15)}`,
                  borderColor: 'error.main'
                }
              }}
            >
              <Avatar
                variant="rounded"
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? toneAlpha('rose', 0.08) : toneAlpha('rose', 0.15),
                  color: 'error.main',
                  width: 52,
                  height: 52,
                  boxShadow: `0 4px 12px ${toneAlpha('rose', 0.05)}`
                }}
              >
                <WarningIcon fontSize="medium" />
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  Annulation
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts.Annulation).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      )}
      <Dialog fullScreen open={openFullScreen} onClose={handleCloseFullScreen}>
        {/* <DialogTitle>Orientations DPC</DialogTitle> */}
        {/* pour supprimer le padding horizontal et vertical autour du datagrid full screen */}
        {/* <DialogContent className={classes.dialogContent}> */}
        <DialogContent>
          {/* <Box className={classes.dataGridContainer}> */}
          <CustomersFollowUpFullScreenTable rows={isLoading ? [] : rows} allFinanciers={allFinanciers} />
          {/* </Box> */}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleCloseFullScreen} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          backgroundColor: "background.default",
        }}
      >
        <Card
          sx={{
            borderRadius: '24px',
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.paper',
            backdropFilter: 'blur(20px)',
            boxShadow: `0 8px 32px ${darkVeil(0.02)}`,
            overflow: 'hidden',
            p: 2
          }}
        >
          <Button
            onClick={() => setOpenFullScreen(true)}
            sx={{ 
              m: 1, 
              mb: 3, 
              borderRadius: '12px', 
              fontWeight: 800, 
              textTransform: 'none', 
              px: 3, 
              py: 1,
              boxShadow: `0 4px 14px ${toneAlpha('blue', 0.25)}`
            }}
            color="primary"
            variant="contained"
          >
            Vue détaillée
          </Button>
          <Box sx={{ mb: 4, px: 1 }}>
            <Card
              sx={{
                p: 3.5,
                borderRadius: '20px',
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'action.hover',
                boxShadow: 'none'
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 3,
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Avatar
                    variant="rounded"
                    sx={{
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                      mr: 2,
                      boxShadow: `0 4px 12px ${toneAlpha('blue', 0.2)}`,
                    }}
                  >
                    <FilterListIcon />
                  </Avatar>
                  <Typography
                    variant="h6"
                    color="textPrimary"
                    sx={{ fontWeight: 800, letterSpacing: '-0.01em' }}
                  >
                    Filtres Avancés
                  </Typography>
                </Box>
                <Button
                  startIcon={<RestartAltIcon />}
                  onClick={() => {
                    setFilterFormation("");
                    setFilterStatus("");
                    setFilterProgression("");
                    setFilterLearner("");
                    setFilterFormat("");
                    setFilterFinanceur("");
                  }}
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 700 }}
                >
                  Réinitialiser
                </Button>
              </Box>
              <Grid container spacing={2.5}>
                <Grid item md={3} xs={12}>
                  <TextField
                    fullWidth
                    label="Nom de formation"
                    variant="outlined"
                    value={filterFormation}
                    onChange={(e) => setFilterFormation(e.target.value)}
                    select
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 400,
                            maxWidth: 500,
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="">Toutes</MenuItem>
                    {[
                      ...new Set(
                        rows.map((row) => row.formation_name).filter(Boolean)
                      ),
                    ]
                      .sort()
                      .map((option) => (
                        <MenuItem
                          key={option}
                          value={option}
                          style={{
                            whiteSpace: "normal",
                            borderBottom: `1px solid ${darkVeil(0.04)}`,
                            padding: "10px 16px",
                          }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={12}>
                  <TextField
                    fullWidth
                    label="Statut"
                    variant="outlined"
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    select
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="">Tous</MenuItem>
                    {[
                      "Inscrit",
                      "InscritD",
                      "À décaler",
                      "Annulation",
                      "En attente",
                      "Décalé",
                    ].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={2} xs={12}>
                  <TextField
                    fullWidth
                    label="Progression"
                    variant="outlined"
                    value={filterProgression}
                    onChange={(e) => setFilterProgression(e.target.value)}
                    select
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="">Toutes</MenuItem>
                    {["0", "25", "50", "75", "100"].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}%
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={2} xs={12}>
                  <TextField
                    fullWidth
                    label="Format"
                    variant="outlined"
                    value={filterFormat}
                    onChange={(e) => setFilterFormat(e.target.value)}
                    select
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="">Tous</MenuItem>
                    {[...new Set(rows.map((row) => row.format).filter(Boolean))]
                      .sort()
                      .map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item md={2} xs={12}>
                  <TextField
                    fullWidth
                    label="Apprenant"
                    variant="outlined"
                    value={filterLearner}
                    onChange={(e) => setFilterLearner(e.target.value)}
                    placeholder="Nom ou Prénom"
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  <TextField
                    fullWidth
                    label="Financeur"
                    variant="outlined"
                    value={filterFinanceur}
                    onChange={(e) => setFilterFinanceur(e.target.value)}
                    select
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="">Tous</MenuItem>
                    {allFinanciers.length > 0 ? (
                      allFinanciers.map((option) => (
                        <MenuItem key={option.name} value={option.name}>
                          {option.name}
                        </MenuItem>
                      ))
                    ) : (
                      [
                        ...new Set(
                          rows.map((row) => row.financeur).filter(Boolean)
                        ),
                      ]
                        .sort()
                        .map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))
                    )}
                  </TextField>
                </Grid>
              </Grid>
            </Card>
          </Box>
          <Box sx={{ px: 1, pb: 3 }}>
            <DataGrid
              density="confortable"
              localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              initialState={{
                sorting: {
                  sortModel: [{ field: "lastname", sort: "asc" }],
                },
              }}
              autoHeight
              rowHeight={90}
              // eslint-disable-next-line consistent-return
              getRowHeight={({ id, densityFactor }) => {
                if (id === clickedId) {
                  return 250 * densityFactor;
                }
              }}
              rows={filteredRows}
              columns={columns}
              pageSize={25}
              rowsPerPageOptions={[5]}
              // onCellEditCommit={handleChange}
              components={{ Toolbar: CustomToolbar }}
              sx={{
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: theme.palette.mode === 'light' ? grey(100) : greyAlpha(900, 0.3),
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  borderRadius: '12px',
                  fontWeight: 700
                },
                '& .MuiDataGrid-columnHeader': {
                  color: 'text.secondary',
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: theme.palette.mode === 'light' ? `1px solid ${grey(100)}` : `1px solid ${lightVeil(0.03)}`,
                  color: 'text.primary',
                  fontSize: '0.85rem'
                },
                '& .MuiDataGrid-cell[data-field="formation_name"]': {
                  whiteSpace: 'normal !important',
                  lineHeight: '1.3 !important',
                  display: 'flex !important',
                  alignItems: 'center !important',
                  py: '8px !important',
                  width: '100% !important'
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: 'action.hover',
                },
                '& .MuiDataGrid-footerContainer': {
                  borderTop: 'none'
                }
              }}
            />
          </Box>
          {/* <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            m: -1,
            p: 2
          }}
        > */}
          {/* <Box
            sx={{
              m: 1,
              maxWidth: '100%',
              width: 500
            }}
          >
            <TextField
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                )
              }}
              onChange={handleQueryChange}
              placeholder="Chercher un apprenant"
              value={query}
              variant="outlined"
            />
          </Box> */}
          {/* <Box
            sx={{
              m: 1,
              width: 240
            }}
          >
            <TextField
              label="Nouveau statut d'appel"
              name="newCallTrack"
              onChange={handleNewCallTrackChange}
              select
              SelectProps={{ native: true }}
              value={currentNewCallTrack}
              variant="outlined"
            >
              {newCallTrackOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
        </Box> */}
        </Card>
      </Box>
    </>
  );
};

export default CustomersFollowUpTable;
